import React from 'react';
import { Tooltip, type TooltipProps } from '@mui/material';
import './ButtonWithTooltip.scss';

export type ButtonWithTooltipProps = {
  title: React.ReactNode;
  children: React.ReactElement;
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
  wrapperClassName?: string;
  wrapperStyle?: React.CSSProperties;
  block?: boolean;
};

export const ButtonWithTooltip: React.FC<ButtonWithTooltipProps> = ({
  title,
  children,
  tooltipProps,
  wrapperClassName,
  wrapperStyle,
  block,
}) => {
  if (!title) return children;

  const isDisabled =
    React.isValidElement(children) &&
    (children.props.disabled || children.props['aria-disabled']);

  const wrapped = (
    <span
      className={`tooltip-wrapper-inline${
        wrapperClassName ? ` ${wrapperClassName}` : ''
      }`}
      style={{ display: block ? 'block' : 'inline-block', ...wrapperStyle }}
      tabIndex={isDisabled ? 0 : undefined}
    >
      {React.cloneElement(children, {
        className: children.props.className,
        style: { ...children.props.style, float: undefined },
      })}
    </span>
  );

  return (
    <Tooltip title={title} {...tooltipProps}>
      {wrapped}
    </Tooltip>
  );
};

export default ButtonWithTooltip;
